import React from "react";
import { useNavigate } from "react-router-dom";

export default function AssessmentResult() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.iconWrap}>✅</div>
        <h1 style={s.title}>Assessment Complete!</h1>
        <p style={s.sub}>Thank you for completing your engagement check-in.</p>

        <div style={s.infoBox}>
          <p style={s.infoText}>
            Your responses have been recorded. Your parent and institution
            will be able to view your engagement report.
          </p>
          <p style={s.infoText}>
            Your next assessment will be available in <strong>15 days</strong>.
          </p>
        </div>

        <button style={s.btn} onClick={() => navigate("/child")}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}

const s = {
  page:     { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", padding: 16 },
  card:     { background: "#fff", borderRadius: 20, padding: "40px 32px", maxWidth: 420, width: "100%", textAlign: "center", boxShadow: "0 4px 32px rgba(0,0,0,0.08)" },
  iconWrap: { fontSize: 52, marginBottom: 16 },
  title:    { fontSize: 22, fontWeight: 700, color: "#0f172a", margin: "0 0 8px" },
  sub:      { fontSize: 14, color: "#64748b", margin: "0 0 24px" },
  infoBox:  { background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 12, padding: "16px 20px", marginBottom: 28, textAlign: "left" },
  infoText: { fontSize: 13, color: "#166534", lineHeight: 1.7, margin: "0 0 6px" },
  btn:      { width: "100%", padding: 14, background: "#1e293b", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 600, cursor: "pointer" },
};
